import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// // import type { Pokemon } from './types';

interface FormResponse {
  success: boolean,
}

export interface EmailForm {
  first_name: string,
  last_name: string,
  email: string,
  phone: string,
  message: string,
}

// Define a service using a base URL and expected endpoints
export const uzeableApi = createApi({
  reducerPath: 'uzeableApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVICE_URL
  }),
  endpoints: (builder) => ({
    contactUs: builder.mutation<FormResponse, EmailForm>({
      query: (emailForm: EmailForm) => ({
        url: 'contact-us',
        method: 'POST',
        headers: { 'x-api-key': process.env.REACT_APP_API_KEY },
        body: emailForm,
      }),
    }),
    hello: builder.query<string, void>({
      query: () => '',
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useContactUsMutation, useHelloQuery } = uzeableApi;